import { defineMessages } from 'react-intl';

export default defineMessages({
    policyTypeTitle: {
        id: 'sticky.card.{type} Policy',
        defaultMessage: '{type} Policy'
    }   
});
